import { CampaignsApi } from '../clients';
import { mapOfficeDiscount } from '../mappers';

/**
 * One office's promo history as rows for its Discounts & Promo Codes tab.
 *
 * The documented envelope is `{ officeId, history: [...] }`; a bare array is
 * accepted too, the same hedge the professional Campaigns service makes for
 * this gateway. Order is preserved — the service returns newest activity first.
 */
export const getOfficeDiscountHistory = async (officeId) => {
  const data = await CampaignsApi.getOfficeDiscountHistory(officeId);
  const list = Array.isArray(data) ? data : data?.history ?? [];
  const now = Date.now();

  return list.map((entry) => mapOfficeDiscount(entry, now));
};
